import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function headerCell(theme: Theme): ComponentStyle {
  return {
    componentName: 'headerCell',
    baseStyle: {
      fontSize: theme.sizes['0'],
      borderTop: 'unset',
      color: theme.colors.muted,
      padding: `0 ${theme.space['xs']} ${theme.space['xs']} ${theme.space['xs']}`
    },
    variants: {
      stuck: {
        position: 'sticky',
        left: '0px',
        zIndex: 1,
        backgroundColor: `${theme.colors.tableStickyBg} !important`,
        borderTopLeftRadius: 'unset'
      }
    }
  };
}
